module.exports = __webpack_public_path__ + "static/img/26-人大附中朝阳分校东坝校区1.f204142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/26-人大附中朝阳分校东坝校区1.png
// module id = HGtT
// module chunks = 0